import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const CartPlusIcon = ({ color = 'black', size = 'md', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} viewBox="0 0 24 25" {...iconSizes[size]} fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M12 3.5C10.2368 3.5 8.77806 4.80385 8.53544 6.5H15.4646C15.2219 4.80385 13.7632 3.5 12 3.5ZM12 2.5C9.68372 2.5 7.77619 4.25002 7.52746 6.5H4H3.5V7V20V20.5H4H20H20.5V20V7V6.5H20H16.4725C16.2238 4.25002 14.3163 2.5 12 2.5ZM4.5 7.5V19.5H19.5V7.5H4.5ZM11.5 10V13H8.5V14H11.5V17H12.5V14H15.5V13H12.5V10H11.5Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
      />
    </svg>
  );
};

export default CartPlusIcon;
